import React from 'react';
import { Routes, Route } from 'react-router-dom';

// 🔐 Pages & Components
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Bookings from './pages/Bookings';
import ExportCSV from './pages/ExportCSV';
import StripeReceipts from './pages/StripeReceipts';
import BlockSuspend from './pages/BlockSuspend';
import UpgradeTier from './pages/UpgradeTier';
import Logs from './pages/Logs';
import AdminLogs from './pages/AdminLogs';
import AdminReportPanel from './pages/AdminReportPanel';
import AdminConditionReportViewer from './pages/AdminConditionReportViewer';
import RentalGuidelinesLog from './pages/RentalGuidelinesLog';
import ProtectedRoute from './components/ProtectedRoute';
import AdminBankApprovalView from './pages/AdminBankApprovalView';
import CreditAdmin from './pages/CreditAdmin';
import FinanceDashboard from './pages/FinanceDashboard';
import ListingLogs from './pages/ListingLogs';
import RefundTool from './pages/RefundTool';
import AdminPayouts from './pages/AdminPayouts';
import StudentVerification from './pages/StudentVerification';
import IdentityVerificationPanel from './pages/IdentityVerificationPanel';
import DepositTool from './pages/DepositTool';
import ConsentLogs from "./pages/ConsentLogs";
import DepositHistory from "./pages/DepositHistory";
import AdminDeposits from './pages/AdminDeposits';
import Broadcast from './pages/Broadcast';

// ✅ NEW: Referrals
import ReferralAdmin from './pages/ReferralAdmin';

// 🚀 App Routing Structure
export default function App() {
  return (
    <Routes>
      {/* Public Route: Login */}
      <Route path="/" element={<Login />} />

      {/* Protected Routes (Admin Only) */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/users"
        element={
          <ProtectedRoute>
            <Users />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/payouts"
        element={
          <ProtectedRoute requireMaster={true}>
            <AdminPayouts />
          </ProtectedRoute>
        }
      />

      <Route path="/broadcast" element={<Broadcast />} />

      <Route
        path="/student-verification"
        element={
          <ProtectedRoute>
            <StudentVerification />
          </ProtectedRoute>
        }
      />

      <Route path="/identity-verification" element={<IdentityVerificationPanel />} />

      <Route
        path="/bookings"
        element={
          <ProtectedRoute>
            <Bookings />
          </ProtectedRoute>
        }
      />
      <Route
        path="/listinglogs"
        element={
          <ProtectedRoute>
            <ListingLogs />
          </ProtectedRoute>
        }
      />
      <Route
        path="/export"
        element={
          <ProtectedRoute>
            <ExportCSV />
          </ProtectedRoute>
        }
      />
      <Route
        path="/receipts"
        element={
          <ProtectedRoute>
            <StripeReceipts />
          </ProtectedRoute>
        }
      />
      <Route
        path="/suspend"
        element={
          <ProtectedRoute>
            <BlockSuspend />
          </ProtectedRoute>
        }
      />
      <Route
        path="/upgrade"
        element={
          <ProtectedRoute>
            <UpgradeTier />
          </ProtectedRoute>
        }
      />
      <Route
        path="/logs"
        element={
          <ProtectedRoute>
            <Logs />
          </ProtectedRoute>
        }
      />

      {/* ✅ Admin-only Master Logs */}
      <Route
        path="/admin-logs"
        element={
          <ProtectedRoute requireMaster={true}>
            <AdminLogs />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/bank-approvals"
        element={
          <ProtectedRoute>
            <AdminBankApprovalView />
          </ProtectedRoute>
        }
      />

      <Route
        path="/refund-tool"
        element={
          <ProtectedRoute>
            <RefundTool />
          </ProtectedRoute>
        }
      />

      <Route path="/deposit-tool" element={<DepositTool />} />
      <Route path="/deposit-history" element={<DepositHistory />} />

      <Route
        path="/admin/deposits"
        element={
          <ProtectedRoute>
            <AdminDeposits />
          </ProtectedRoute>
        }
      />

      {/* 📸 Condition Reports Viewer */}
      <Route
        path="/condition-reports"
        element={
          <ProtectedRoute>
            <AdminConditionReportViewer />
          </ProtectedRoute>
        }
      />

      {/* 🚩 Report Panel */}
      <Route
        path="/admin/reports"
        element={
          <ProtectedRoute>
            <AdminReportPanel />
          </ProtectedRoute>
        }
      />

      {/* 💳 Credit Admin */}
      <Route
        path="/credit-admin"
        element={
          <ProtectedRoute>
            <CreditAdmin />
          </ProtectedRoute>
        }
      />

      <Route path="/consents" element={<ConsentLogs />} />

      {/* ✅ NEW: Rental Guidelines Log Viewer */}
      <Route
        path="/guideline-logs"
        element={
          <ProtectedRoute>
            <RentalGuidelinesLog />
          </ProtectedRoute>
        }
      />

      {/* ✅ Admin-only Finance Dashboard */}
      <Route
        path="/finance-dashboard"
        element={
          <ProtectedRoute requireMaster={true}>
            <FinanceDashboard />
          </ProtectedRoute>
        }
      />

      {/* ✅ NEW: Referrals Admin */}
      <Route
        path="/referrals"
        element={
          <ProtectedRoute>
            <ReferralAdmin />
          </ProtectedRoute>
        }
      />
      {/* optional alias */}
      <Route
        path="/referral-admin"
        element={
          <ProtectedRoute>
            <ReferralAdmin />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}
